import React from "react";
import { CategoryStandardProduct } from "shared/api/middleware-api-client";
import { REACT_APP_GERS_API_URL } from "shared/config";
import CheckmarkIcon from "shared/ui/icons/CheckmarkIcon";
import { MultiplierIcon } from "shared/ui/icons/Multiplier";
import { getFormattedPrice } from "shared/utils/getFormattedPrice";
import { PANEL_SET_CODES } from "shared/utils/standard-product";

interface ProductProps {
  product: CategoryStandardProduct;
  totalPrice: string;
  monthlyPayment: number;
}

export const StandardProductColumn = ({
  product,
  totalPrice,
  monthlyPayment,
}: ProductProps) => {
  const imageSource = `${REACT_APP_GERS_API_URL}/StandardProducts/download-file/${product.imageId}`;
  const formattedMonthlyPayment = getFormattedPrice(monthlyPayment);
  const productAmount =
    product.amount * (PANEL_SET_CODES.includes(product.code) ? 2 : 1);
  return (
    <div className="gg-border-1 gg-relative gg-col-span-9 gg-bg-white gg-px-6 gg-pb-5 sm:gg-pb-6 lg:gg-col-span-4 xl:gg-pb-5">
      <div className="gg-relative gg-mx-auto gg-mt-12 gg-flex gg-justify-center lg:gg-mt-10">
        <div className="gg-relative">
          <img
            src={imageSource}
            className="gg-aspect-[8/6] gg-w-48 gg-bg-gray-50 gg-object-cover gg-object-center sm:gg-w-56"
            alt="Standard Product"
          />
          <span className="gg-absolute -gg-right-3 -gg-top-3 gg-grid gg-place-items-center gg-rounded-full gg-bg-[#69B578]">
            <CheckmarkIcon />
          </span>
        </div>
      </div>

      <div className="gg-mt-3.5 gg-w-full gg-text-xl gg-font-bold gg-leading-7 gg-text-dark-blue sm:gg-text-2xl">
        Jouw product is aan je winkelmand toegevoegd!
      </div>

      <div className="gg-mt-5 gg-w-full gg-text-base gg-font-bold gg-leading-6 gg-text-dark-blue">
        Jouw keuze
      </div>

      {/* Jouw keuze */}
      <div className="gg-mt-1.5 gg-grid gg-grid-cols-2 gg-gap-x-4 gg-gap-y-3 gg-bg-gray-100 gg-px-5 gg-py-5 gg-text-sm gg-text-dark-blue">
        <div className="gg-flex gg-flex-col">
          <div className="gg-font-bold">Product</div>
          <span>
            {product.productType.code !== "accessoire"
              ? product.productType.name
              : product.name}
          </span>
        </div>

        {product.productType.code !== "accessoire" && (
          <div className="gg-flex gg-flex-col">
            <div className="gg-font-bold">Kleur</div>
            <span>{product.shortname} </span>
          </div>
        )}

        <div className="gg-flex gg-h-full gg-flex-col">
          <div className="gg-font-bold">Aantal</div>
          <div className="gg-flex gg-w-full gg-flex-row">
            <span className="gg-text-start">{productAmount}</span>
            <span className="gg-ml-[0.05rem] gg-self-center">
              <MultiplierIcon />
            </span>
          </div>
        </div>
      </div>

      {/* Totaal */}
      <div className="gg-flex gg-flex-col gg-pt-5">
        <div className="gg-flex gg-justify-between">
          <div className="gg-font-bold gg-text-dark-blue">Totaal</div>
          <div className="gg-flex gg-items-center gg-gap-1 gg-font-bold gg-text-dark-blue">
            <span>{totalPrice}</span>
          </div>
        </div>

        <div className="gg-mt-1 gg-flex gg-justify-between">
          <div className="gg-text-xs gg-text-[#9493A3]">Incl. btw</div>
          {monthlyPayment > 0 && (
            <span className="gg-text-xs gg-text-[#9493A3]">
              of v.a. {formattedMonthlyPayment} per maand
            </span>
          )}
        </div>
      </div>
    </div>
  );
};
